<template>
  <div style="height: 100%;display: flex;flex-direction: row;">
    <SaleafterPlan @reload="detailKey++" style="width: 250px; height: unset; flex: unset;" @item-choose="item => chooseData = item" />
    <SaleafterDetail :key="detailKey" v-if="chooseData" :goodsSaleAfterId="chooseData.id" style="flex: 1; width: 0;height: unset;margin-left: 0;padding: 0;" />
  </div>
</template>

<script>
import SaleafterDetail from './detail.vue'
import SaleafterPlan from '../../components/goods/saleafter/plan.vue'

export default {
  components: { SaleafterPlan, SaleafterDetail },
  props: {},
  data () {
    return {
      chooseData: null,
      detailKey: 0
    }
  }
}
</script>